import { type FC, type ReactNode, useEffect, useRef } from 'react'
import { useIsInView } from '../../hooks'

interface InfiniteScrollWrapperProps {
  onLoadMore: () => void
  hasMore: boolean
  isLoading?: boolean
  children: ReactNode
  className?: string
}

export const InfiniteScrollWrapper: FC<InfiniteScrollWrapperProps> = ({
  onLoadMore,
  hasMore,
  isLoading = false,
  children,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null)

  const { isInView } = useIsInView({ ref })

  useEffect(() => {
    if (isInView && hasMore && !isLoading) {
      onLoadMore()
    }
  }, [isInView, onLoadMore, hasMore, isLoading])

  return (
    <div className={className}>
      {children}
      <div ref={ref} className="h-4" />
    </div>
  )
}
